module.exports = __webpack_public_path__ + "img/powercell_logo_white.b17a50a8.png";